import {Layout} from "./Layout.js";
import {SignUpViewChanger} from "../../util/view-changer/index.js";


export class InviteLayout extends  Layout {

    template() {
        const {sectionId = '', } = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                           ${this.getCompanyGenerateWrapTemplate()}
                          <ul id="inviterUl" class="invite-list"></ul>
                          ${this.getNextLinkTemplate()}
                        </div>
                    </article>
                </section>`
    }

    getCompanyGenerateWrapTemplate() {
        if(Often.isGlobal()) {
            return  ``;
        }
        return `
             <div class="project-generate-wrap">
                            ${this.getNexPageButtonTemplate()}
                          </div>
        `
    }
    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;
        if (Object.values(nextButton).length === 0) {
            return "";
        }
        return `
                <em>${Mutil.n2v(nextButton.mainLabel)}</em>
                <p>${Mutil.n2v(nextButton.subLabel)}</p>
                <button id = "${Mutil.n2v(nextButton.id)}" class="js-next-page-button" >${Mutil.n2v(nextButton.text)}</button>`
    }

    getInviteUlLayer() {
        return $("#inviterUl");
    }
}